export { AddMovingDetails } from './add-moving-details.component';
